import i18n from 'translations/i18n'
import { useMemo } from 'react'
import { crType, sub_crType } from 'redux/publicTemplates/publicTemplateTypes'
import FilterBox from '../FilterBox'
import useFilterAPI from '../useFilterAPI'
import { useFilters } from './context'

type CRTypesTypes = {
  filterKey: string
  crId?: number
}

const CommercialRegistrations = (props: CRTypesTypes): JSX.Element => {
  const { crId } = props
  const { commercial_registration } = useFilterAPI()
  const { filter, handleFilter, setFilter } = useFilters()
  const findFamilyCR = useMemo(
    () =>
      crId
        ? [commercial_registration.find((it: crType) => it.id === crId)]
        : commercial_registration,
    [commercial_registration, crId],
  )
  const list = findFamilyCR[0]?.sub_commercial_registrations?.map((it: sub_crType) => ({
    ...it,
    sub_commercial_registrations: [],
  }))
  const filterOptions = { ...findFamilyCR[0], sub_commercial_registrations: list }

  const onHandleFilter = (_: string, val: string): void => {
    if (filter[props.filterKey].length === 1) {
      setFilter({
        ...filter,
        commercial_registration_ids:
          val === filter[props.filterKey]
            ? [val]
            : [...new Set([...filter.commercial_registration_ids, val])],
      })
    } else {
      handleFilter('commercial_registration_ids', val)
    }
  }

  return (
    <FilterBox
      handleFilter={onHandleFilter}
      options={[filterOptions]}
      selectedIds={filter[props.filterKey]}
      isClearable={false}
      {...props}
      componentType="multiLevel"
      title={i18n.t('organizations')}
      childKey="sub_commercial_registrations"
      labelKey="name"
      valueKey="id"
    />
  )
}

export default CommercialRegistrations
